import { useState } from "react";
import { Shell } from "@/components/Shell";
import { AdminQuestions } from "@/pages/admin/AdminQuestions";
import { AdminUsers } from "@/pages/admin/AdminUsers";
import { AdminSubmissions } from "@/pages/admin/AdminSubmissions";
import { AdminLeaderboard } from "@/pages/admin/AdminLeaderboard";
import { AdminSeason } from "@/pages/admin/AdminSeason";

const TABS = [
  { id: "questions", label: "Questions", C: AdminQuestions },
  { id: "users", label: "Users", C: AdminUsers },
  { id: "submissions", label: "Entries", C: AdminSubmissions },
  { id: "leaderboard", label: "Ranking", C: AdminLeaderboard },
  { id: "season", label: "Season", C: AdminSeason },
];

export default function Admin() {
  const [tab, setTab] = useState("questions");
  const Active = TABS.find((t) => t.id === tab).C;
  return (
    <Shell width="wide">
      <p className="eyebrow">Protected area</p>
      <h1 className="mt-2 font-display text-3xl font-extrabold tracking-tight md:text-4xl" data-testid="admin-title">Admin</h1>
      <div className="mt-5 grid grid-cols-5 gap-1 rounded-xl border border-slate-800 p-1 md:inline-grid md:w-auto" data-testid="admin-tabs">
        {TABS.map((t) => (
          <button key={t.id} onClick={() => setTab(t.id)} className={`rounded-lg px-1 py-2 text-xs font-medium transition-colors md:px-5 md:text-sm ${tab === t.id ? "bg-white text-slate-900" : "text-slate-400 hover:bg-slate-800 hover:text-white"}`} data-testid={`admin-tab-${t.id}`}>{t.label}</button>
        ))}
      </div>
      <div className="mt-5"><Active /></div>
    </Shell>
  );
}
